import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Rub = function Rub(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#RUB_svg__RUB_svg__clip0_9086_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0z",
    fill: "#ECEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.656 5.263h1.072c1.012 0 1.531.52 1.531 1.345 0 .837-.52 1.356-1.536 1.356H7.656V5.263zm2.188 5.61v-.918H7.656v-.88h1.417c1.57 0 2.62-1.045 2.62-2.478 0-1.438-1.018-2.488-2.56-2.488H6.245v3.866H5.223v1.083h1.022v.897H5.223v.918h1.022V12h1.411v-1.127h2.188z",
    fill: "#505F79"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "RUB_svg__RUB_svg__clip0_9086_27"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
export default Rub;